import Footer from './src/main';

/* istanbul ignore next */
Footer.install = function(Vue) {
  Vue.component(Footer.name, Footer);
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/element/packages/footer/index.js